import React, { Fragment, useState } from 'react';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import config, {
  bankTransactionType,
  paymentMethodsList,
  subCategoryIdList,
  transactionTypes,
  TRIGGERS,
} from '@/api/global';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import Button from '@/components/common/Button';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import { avatarBg } from '@/functions/formats';
import AppRadio from '@/components/common/AppRadio';
import AppRadiochecked from '@/components/common/AppRadioChecked';
import FinesWithoutIdentityForm from '../FinesWithoutIdentityForm';
import Api from '@/api';
import CookieFunction from '@/functions/cookieFunction';

export default function PaymentModal() {
  const {
    priceSymbol,
    setTrigger,
    paymentInfo,
    walletInfo,
    payPrice,
    loadingPayment,
    isLogin,
    showError,
  } = useLayoutContext();
  // const isLogin= CookieFunction('get', config.tokenName)
  const hideWalletOption =
    !isLogin && paymentInfo?.item?.key == subCategoryIdList.fines_without_identity_verification
      ? true
      : false;
  const [active, setActive] = useState(paymentInfo?.type == 'inq' && !hideWalletOption ? 1 : 2);
  const tCommon = useTranslations('common');
  const [info, setInfo] = useState<any>({
    national_code: '',
    mobile: '',
    license_plate_number: null,
    error: {
      mobile: false,
      national_code: false,
      license_plate_number: false,
    },
    messages: {
      mobile: tCommon('requiredField'),
      national_code: tCommon('requiredField'),
      license_plate_number: tCommon('requiredField'),
    },
  });
  const checkError = () => {
    let dummy = { ...info };
    let result = false;

    const values: (keyof typeof info)[] = ['mobile', 'national_code', 'license_plate_number'];

    values.forEach((item) => {
      if (String(info?.[item] ?? '').trim().length === 0) {
        dummy.error[item] = true;
        result = true;
      }
    });
    if (info?.license_plate_number) {
      const isFilled = Object.values(dummy?.license_plate_number?.plate).every(
        (value) => String(value).trim() !== '',
      );
      if (!isFilled) {
        dummy.error['license_plate_number'] = true;
        dummy.messages['license_plate_number'] = 'پلاک را کامل وارد کنید';

        result = true;
      }
    }
    setInfo({ ...dummy });
    return result;
  };

  const onConfirm = () => {
    console.log('payinfo==', { ...paymentInfo, payment_method: active });
    let values = { ...paymentInfo, payment_method: active };
    if (!hideWalletOption) {
      payPrice(values);
    } else {
      let check = checkError();
      if (!check) {
        let license_plate_number =
          info?.license_plate_number?.plate?.r +
          info?.license_plate_number?.plate?.code +
          info?.license_plate_number?.plate?.a +
          info?.license_plate_number?.plate?.c;
        let params = {
          source_id: Number(paymentInfo?.item?.id),
          sub_type: transactionTypes.TransactionSubTypeNajiCall,
          type: bankTransactionType.withdraw,
          mobile: info?.mobile,
          national_code: info?.national_code,
          license_plate_number: license_plate_number,
          method: 2,
        };
        Api.payment(params)
          .then((res) => {
            if (res?.data?.url) {
              window.location.href = res?.data?.url;
            }
          })
          .catch((err) => {
            showError(err);
          });
      }
    }
  };
  const onClose = () => {
    setTrigger(TRIGGERS.EMPTY);
  };
  console.log('paymentInfo====', paymentInfo);
  const paymentMethods = [
    paymentInfo?.type == 'inq' && !hideWalletOption
      ? {
          id: paymentMethodsList?.wallet,
          title: 'کیف پول کارا',
          text: (
            <PriceSection className={styles.wallet} prefix={'موجودی'} value={walletInfo?.balance} />
          ),
          bg: avatarBg(8),
          color: 'var(--danger)',
        }
      : null,
    {
      id: paymentMethodsList?.bank,
      title: 'پرداخت آنلاین',
      text: 'انتقال به درگاه بانکی امن',
      bg: avatarBg(6),
      color: 'var(--purple)',
    },
  ];
  console.log('active======', active);
  console.log('paymentInfo====', paymentInfo);
  return (
    <div className={styles.body}>
      <div className={styles.feeRow}>
        <span>{paymentInfo?.type == 'inq' ? 'هزینهٔ استعلام' : 'مبلغ'}</span>
        <PriceSection value={paymentInfo?.item?.price} className={styles.feeVal} />
      </div>

      <div className={styles.options}>
        {paymentMethods?.map((item, index) => (
          <Fragment key={index}>
            {item && (
              <div
                className={`${styles.itemContainer} ${styles.item} ${active == item?.id && styles.activeBox}`}
                onClick={() => {
                  setActive(item?.id);
                }}
              >
                <PageCardHeader
                  key={index}
                  title={item?.title}
                  text={item?.text}
                  icon={<MainIcons.walletIcon fill={item?.color} width="22px" height="22px" />}
                  iconClass={`${styles.itemIconClass}`}
                  backgroundIcon={item?.bg}
                  // className={`${styles.item}`}
                />
                <AppRadiochecked active={active == item?.id} />
              </div>
            )}
          </Fragment>
        ))}
      </div>
      {hideWalletOption && <FinesWithoutIdentityForm info={info} setInfo={setInfo} />}
      <Button
        type="button"
        className={`btn btn-primary squareButton ${styles.confirm}`}
        onClick={onConfirm}
        loading={loadingPayment?.inq}
      >
        <MainIcons.LockIcon width="18px" height="18px" fill="var(--paper)" />
        {'پرداخت و استعلام'} · {paymentInfo?.item?.price?.toLocaleString()} {priceSymbol}
      </Button>
      <button type="button" className={styles.cancel} onClick={onClose}>
        {tCommon('cancel')}
      </button>
      <div className={styles.secure}>
        <MainIcons.shieldIcon width="14px" height="14px" fill="var(--green)" />
        پرداخت امن و رمزگذاری‌شده
      </div>
    </div>
  );
}
